import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SupplierOrder\CreateSupplierOrderWithItemDossierController::__invoke
* @see app/Http/Controllers/SupplierOrder/CreateSupplierOrderWithItemDossierController.php
* @route '/api/supplier-order/create-with-item-dossier'
*/
const CreateSupplierOrderWithItemDossierController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateSupplierOrderWithItemDossierController.url(options),
    method: 'post',
})

CreateSupplierOrderWithItemDossierController.definition = {
    methods: ["post"],
    url: '/api/supplier-order/create-with-item-dossier',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SupplierOrder\CreateSupplierOrderWithItemDossierController::__invoke
* @see app/Http/Controllers/SupplierOrder/CreateSupplierOrderWithItemDossierController.php
* @route '/api/supplier-order/create-with-item-dossier'
*/
CreateSupplierOrderWithItemDossierController.url = (options?: RouteQueryOptions) => {
    return CreateSupplierOrderWithItemDossierController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SupplierOrder\CreateSupplierOrderWithItemDossierController::__invoke
* @see app/Http/Controllers/SupplierOrder/CreateSupplierOrderWithItemDossierController.php
* @route '/api/supplier-order/create-with-item-dossier'
*/
CreateSupplierOrderWithItemDossierController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateSupplierOrderWithItemDossierController.url(options),
    method: 'post',
})

export default CreateSupplierOrderWithItemDossierController